import { motion } from 'framer-motion';
import { styled } from 'styled-components';

export const DividerContainer = styled(motion.div)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  color: var(--pcm-body-color-tertiary);
  font-weight: 400;
  font-size: 12px;
  margin: 20px 0;
  pointer-events: none;
  user-select: none;
  white-space: nowrap;

  &:before {
    content: '';
    transition: all 200ms ease;
    height: 1px;
    width: 100%;
    background: var(--pcm-body-background-tertiary);
  }

  &:after {
    content: '';
    transition: all 200ms ease;
    height: 1px;
    width: 100%;
    background: var(--pcm-body-background-tertiary);
  }
`;
